import { c as _c } from "react/compiler-runtime";
import { TimerStartIcon } from '@navikt/aksel-icons';
import { ExpansionCard, HStack } from '@navikt/ds-react';
import Knappenavn from './Knappenavn';
import styles from './Seksjon.module.css';
import { store } from '@/app/_components/store/store';
import SeksjonsListe, { SeksjonsFelt } from '@/components/seksjons-liste';
import SortedTable from '@/components/sorted-table';
import { TimerMedTimeloenn as TimerMedTimeLoennType } from 'types/arbeidsforhold';
import { formatDateMonth, formatDatePeriode } from 'utils/formatting/dato';
interface Props {
  data: Array<TimerMedTimeLoennType> | null;
}
const TimerMedTimeloenn = props => {
  const $ = _c(34);
  const texts = store.useReducerState().tekst;
  let t0;
  if ($[0] !== texts._locale) {
    t0 = value => formatDateMonth(value.rapporteringsmaaned, texts._locale);
    $[0] = texts._locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0 || $[3] !== texts.hjelpetekst.timerForTimeloennet.rapporteringsmaaned || $[4] !== texts.timerForTimeloennet.rapporteringsmaaned) {
    t1 = {
      label: texts.timerForTimeloennet.rapporteringsmaaned,
      hjelpetekst: texts.hjelpetekst.timerForTimeloennet.rapporteringsmaaned,
      getValue: t0,
      sortValue: _temp
    };
    $[2] = t0;
    $[3] = texts.hjelpetekst.timerForTimeloennet.rapporteringsmaaned;
    $[4] = texts.timerForTimeloennet.rapporteringsmaaned;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== texts.hjelpetekst.timerForTimeloennet.opptjeningsperiode || $[7] !== texts.timerForTimeloennet.opptjeningsperiode) {
    t2 = {
      label: texts.timerForTimeloennet.opptjeningsperiode,
      hjelpetekst: texts.hjelpetekst.timerForTimeloennet.opptjeningsperiode,
      getValue: _temp2,
      minWidth: 160
    };
    $[6] = texts.hjelpetekst.timerForTimeloennet.opptjeningsperiode;
    $[7] = texts.timerForTimeloennet.opptjeningsperiode;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== texts.hjelpetekst.timerForTimeloennet.antallTimer || $[10] !== texts.timerForTimeloennet.antallTimer) {
    t3 = {
      label: texts.timerForTimeloennet.antallTimer,
      hjelpetekst: texts.hjelpetekst.timerForTimeloennet.antallTimer,
      getValue: _temp3
    };
    $[9] = texts.hjelpetekst.timerForTimeloennet.antallTimer;
    $[10] = texts.timerForTimeloennet.antallTimer;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3) {
    t4 = [t1, t2, t3];
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const felter = t4;
  let t5;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div><TimerStartIcon aria-hidden={true} className={styles.ikon} /></div>;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== texts.timerForTimeloennet.timerForTimeloennet) {
    t6 = <ExpansionCard.Header><HStack wrap={false} gap="space-16" align="center" className={styles.header}>{t5}<div><ExpansionCard.Title>{texts.timerForTimeloennet.timerForTimeloennet}</ExpansionCard.Title></div></HStack></ExpansionCard.Header>;
    $[17] = texts.timerForTimeloennet.timerForTimeloennet;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t6 || $[20] !== texts.timerForTimeloennet.timerForTimeloennet) {
    t7 = <Knappenavn navn={texts.timerForTimeloennet.timerForTimeloennet}>{t6}</Knappenavn>;
    $[19] = t6;
    $[20] = texts.timerForTimeloennet.timerForTimeloennet;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== felter || $[23] !== props.data || $[24] !== texts.filter || $[25] !== texts.timerForTimeloennet.ingenTreff || $[26] !== texts.timerForTimeloennet.rapporteringsmaaned) {
    t8 = props.data == null ? texts.filter.ikkeValgt : props.data?.length === 0 ? texts.timerForTimeloennet.ingenTreff : <><div className={styles.kunBred}><SortedTable simple={true} initialData={props.data || []} itemsToShow={3} sortable={false} orderBy={texts.timerForTimeloennet.rapporteringsmaaned} direction="descending" fields={felter} /></div><div className={styles.kunSmal}><SeksjonsListe data={props.data || []} felter={felter} noekkel={0} itemsToShow={3} /></div></>;
    $[22] = felter;
    $[23] = props.data;
    $[24] = texts.filter;
    $[25] = texts.timerForTimeloennet.ingenTreff;
    $[26] = texts.timerForTimeloennet.rapporteringsmaaned;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t8) {
    t9 = <ExpansionCard.Content className={styles.innhold}>{t8}</ExpansionCard.Content>;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== t7 || $[31] !== t9 || $[32] !== texts.timerForTimeloennet.timerForTimeloennet) {
    t10 = <ExpansionCard aria-label={texts.timerForTimeloennet.timerForTimeloennet} defaultOpen={true} className={styles.kort}>{t7}{t9}</ExpansionCard>;
    $[30] = t7;
    $[31] = t9;
    $[32] = texts.timerForTimeloennet.timerForTimeloennet;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  return t10;
};
export default TimerMedTimeloenn;
function _temp(value_0) {
  return value_0.rapporteringsmaaned;
}
function _temp2(value_1) {
  return formatDatePeriode(value_1.startdato, value_1.sluttdato);
}
function _temp3(value_2) {
  return value_2.antall;
}